import { useContext } from 'react';
import classNames from 'classnames';
import { bool, func, number, oneOfType, string } from 'prop-types';

import { BundleCampaignContext } from '~/components/LootPackViews/BundleSelector/BundleCampaignProvider';

import { ReactComponent as BundleCampaignIndicator } from '~/assets/images/payments/campaign-indicator.svg';
import { ReactComponent as ToolTipTriangle } from '~/assets/images/payments/tooltip-triangle.svg';

import style from './BundleSelector.module.scss';

const BundleButton = ({ selected, bundle, bonus, onClick, available }) => {
  const { show, bundles, bundleCampaignToIndicate, setShow } = useContext(
    BundleCampaignContext,
  );
  const shouldIndicateCampaign = bundles?.includes(bundle);
  const shouldDisplayTooltip =
    show && bundleCampaignToIndicate?.bundleIncluded === bundle;

  const onClickWrapped = () => {
    if (available) {
      onClick();
      if (setShow) {
        setShow(true);
      }
    }
  };

  return (
    <div
      className={classNames(style.bundleButton, {
        selected,
        disabled: !available,
      })}
      onClick={onClickWrapped}
    >
      <div>
        <span>{bundle}</span>
      </div>
      {bonus && !shouldDisplayTooltip && (
        <div className={style.bonus}>
          <span>
            {'+'}
            {bonus}
          </span>
        </div>
      )}
      {shouldIndicateCampaign && (
        <BundleCampaignIndicator className={style.campaignIndicator} />
      )}
      {shouldDisplayTooltip && (
        <ToolTipTriangle className={style.tooltipTriangle} />
      )}
    </div>
  );
};

BundleButton.propTypes = {
  selected: bool,
  available: bool,
  bundle: string,
  bonus: oneOfType([string, number, bool]),
  onClick: func.isRequired,
};

export default BundleButton;
